export const data = [
	{
		to: '/',
		text: 'Home',
		id: 'about',
	},
	{
		to: '/pricing',
		text: 'Pricing',
	},
	{
		to: '/signup',
		text: 'Contact',
	},
];
